import { Builder } from '@builder.io/react'

import { FooterAccordion } from './FooterAccordion'
import { defaultItems } from './FooterAccordion.defaults'

Builder.registerComponent(FooterAccordion, {
  name: 'FooterAccordion',
  inputs: [
    {
      name: 'items',
      type: 'list',
      subFields: [
        {
          name: 'titleContent',
          type: 'uiBlocks',
        },
        {
          name: 'content',
          type: 'uiBlocks',
        },
      ],
      defaultValue: defaultItems,
    },
  ],
})
